import script from "./Role.vue?vue&type=script&lang=ts&setup=true"
export * from "./Role.vue?vue&type=script&lang=ts&setup=true"

import "./Role.vue?vue&type=style&index=0&id=13308041&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13308041"]])

export default __exports__